export function getPdfViewerEnabledTools({ toolbarTools, tools }) {
  return toolbarTools.filter(toolbarTool => tools.includes(toolbarTool))
}

export function getPdfViewerEnabledToolGroups({ groups, tools }) {
  return groups.reduce((enabledGroups, group) => {
    const groupTools = getPdfViewerEnabledTools({
      toolbarTools: group.tools,
      tools,
    })

    if (groupTools.length > 0) {
      enabledGroups.push({ ...group, tools: groupTools })
    }

    return enabledGroups
  }, [])
}

export function getPdfViewerToolbarSelectableOptions({
  options,
  selectedValue,
  onSelect,
}) {
  return options.map(option => ({
    ...option,
    isSelected: option.value === selectedValue,
    onSelect,
  }))
}
